import { useCommonConfiguration } from '../../../hooks/useCommonConfiguration';

// TODO: temporary hooks only for making requests to Meta tags
export const useIsEnabledLanguageInRequests = () => {
  const commonConfig = useCommonConfiguration();
  return commonConfig?.isMetaTagsTranslates || false;
};
